import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal ,NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from 'src/app/notification.service';
import { ClientService } from 'src/app/services/Client/client.service';
import * as CommonFunction from '../../../services/common.function';
import { DatatransferService } from 'src/app/services/DataTransfer/datatransfer.service';
import { ModulesService } from 'src/app/services/Authetication/menu-permission/modules.service';
import * as commonConstant from 'src/app/services/common.constant';

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.css']
})
export class ParametersComponent implements OnInit {

  clientResponse: any;
  listingBodyParameter: any;
  clientId!: string;
  clientName: any;
  email: any;
  expiryDate: any;
  contactName: any;
  contactNo: any;
  isActive: any;
  UserCount: any;
  TeamCount: any;
  ProductCount: any;
  loCurrentUserData: any;
  TimeZone: any;
  monitoringFrequency ?: string;
  paymentProfile ?: string;
  stReportTypesClient: any;

  constructor(
    private _notificationService: NotificationService,
    private _modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private _modulesService: ModulesService,
    private _dataService: DatatransferService,
    private _clientService: ClientService,
    private config: NgbModalConfig,
    private _Router: Router
  ) {
      config.backdrop = 'static';
      config.keyboard = false;
      this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
      this.TimeZone =CommonFunction.GetTimeZone();
  }

  ngOnInit(): void {
    let isSetPassword = CommonFunction.isSetPasswordByUser();
    if (!isSetPassword) {
      window.location.href = 'setnewpassword';
    }
    this.getRoleByRoleId();
    this._dataService.ViewPageCountsMessage.subscribe(CountData => {
      if (CountData != null || CountData != "") {
        this.UserCount = CountData.users;
        this.TeamCount = CountData.teamCounts;
      }
    });
    if (document.querySelector('a[href="/parameters"]') != null) {
      document.querySelector('a[href="/parameters"]')?.setAttribute('class', 'active');
    }
  }


  ngOnDestroy() {
    if (document.querySelector('a[href="/parameters"]') != null) {
      document.querySelector('a[href="/parameters"]')?.setAttribute('class', '');
    }

  }



  async getRoleByRoleId() {
    this.spinner.show();
    await this._modulesService.getRoleByRoleId(this.loCurrentUserData.roleId).subscribe(
      {
        next: (response: any) => {
          if (!!response) {
            if (response.statusCode == 200) {
              if (response.data.role.name.toLowerCase() == "client admin") {
                this.getClientDetails(this.loCurrentUserData.clientId);
              }
            }
          }
        },
        error: (error) => {
          if (error != undefined) {
            if (error.status == 401) {
              this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
              this._Router.navigate(['login']);
            }
          }
        }
      });
  }

  getClientDetails(uiclientId: any) {
    let dt = {
      TimeZone: this.TimeZone,
      clientId: uiclientId,
      stSearchText: "",
      stSortColumn: "stClient",
      stSortOrder: "",
      inOffset: 0,
      inLimit: 0
    };

    this.spinner.show();
    this._clientService.viewClient(dt).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this.spinner.hide();
              this.clientResponse = response.data.resultSet;
              localStorage.setItem('ViewClienName', response.data.resultSet[0].client);
              this.clientName = response.data.resultSet[0].client;
              this.email = response.data.resultSet[0].email;
              this.expiryDate = response.data.resultSet[0].expiryDate;
              this.contactName = response.data.resultSet[0].contactName;
              this.contactNo = response.data.resultSet[0].contactNumber;
              this.isActive = response.data.resultSet[0].isActive;
              this.UserCount = response.data.resultSet[0].users;
              this.TeamCount = response.data.resultSet[0].teamCounts;
              this.ProductCount = response.data.resultSet[0].productCounts;
              this.monitoringFrequency = response.data.resultSet[0].monitoringFrequency == null ? "-" : response.data.resultSet[0].monitoringFrequency;
              this.paymentProfile = response.data.resultSet[0].paymentProfile == null ? "-" : response.data.resultSet[0].paymentProfile;
              this.stReportTypesClient = response.data.resultSet[0].stReportTypes;
              localStorage.setItem('currentViewClientExpiryDate', this.expiryDate);
              localStorage.setItem('isClientActive',response.data.resultSet[0].isActive);
            }
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.clientResponse = {
            resultSet: []
          };
          if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error'); // unknown error
          } else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", 'Error');
          }
        }
      });
  }
}